import 'jquery-countdown';
import moment from 'moment';

window.onload = () => {
  const $sliderCountdown = $('#countdown-slide_target');

  if($sliderCountdown) {
    const startingDate = '2020-11-21';
    const futureDate = moment(startingDate).add(1, 'M').format('YYYY-MM-DD');
  
    $sliderCountdown.countdown(futureDate, event => {
      $(event.currentTarget).html(event.strftime(''
        + '<p class="count-digits">%-D<span>days</span></p>'
        + '<p class="count-digits">%H<span>hours</span></p>'
        + '<p class="count-digits">%M<span>minutes</span></p>'
        + '<p class="count-digits">%S<span>seconds</span></p>'));
    });
  }
}